import React from 'react';
import { Link } from 'react-router-dom';
import PublicSEO from '../../components/public/PublicSEO';
import { publicPath } from '../../utils/canonicalUrl';
import { buildBreadcrumb } from '../../utils/jsonLd';
import './ContentGuide.css';

export default function ComeFunzionaPage() {
  return (
    <div className="vc-guide">
      <PublicSEO
        title="Come funziona Virtual Clinic"
        description="Dal sintomo allo slot: cerca disponibilità, prenota in studio o in video, preparati alla visita, sposta l'appuntamento e consulta i documenti nell'area Oggi."
        canonicalPath="/come-funziona"
        jsonLd={[
          buildBreadcrumb([
            { name: 'Home', path: '/' },
            { name: 'Come funziona' },
          ]),
        ]}
      />
      <div className="vc-guide__inner">
        <h1>Come funziona</h1>
        <p className="vc-guide__lead">
          Percorso chiaro dalla ricerca alla visita, con strumenti per prima e dopo l&apos;appuntamento.
        </p>

        <section>
          <h2>1. Cerca disponibilità</h2>
          <p>
            In <Link to={publicPath('/ricerca')}>Visite ed esami</Link> indichi prestazione, zona e come paghi.
            Confronti medici, modalità (in studio / in video), prezzi e prossimi orari liberi.
          </p>
        </section>

        <section>
          <h2>2. Scegli prestazione, giorno e ora</h2>
          <p>
            Sul profilo del medico selezioni la prestazione, un giorno con posti liberi e uno slot.
            Puoi iniziare senza account: ti chiediamo di accedere o registrarti prima di confermare.
          </p>
        </section>

        <section>
          <h2>3. Area «Oggi»</h2>
          <p>
            Nell&apos;area paziente trovi la prossima visita, la checklist di preparazione,
            il pulsante per provare audio e video (se in video), e il link per spostare l&apos;appuntamento
            quando le regole di preavviso lo consentono.
          </p>
        </section>

        <section>
          <h2>4. Dopo la visita</h2>
          <p>
            Dove previsto puoi lasciare un feedback sulla visita completata e, se il medico lo suggerisce,
            prenotare un controllo consigliato.
          </p>
          <div className="vc-guide__cta-row">
            <Link to={publicPath('/ricerca')} className="vc-guide__cta">Cerca disponibilità</Link>
            <Link to={publicPath('/fondi-sanitari')} className="vc-guide__cta vc-guide__cta--secondary">Fondi e assicurazioni</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
